var Component = require("../../model/Component");

Component.registerSubTypeDefaulter('dataZoom', function () {
  // Default 'slider' when no type specified.
  return 'slider';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/dataZoom/typeDefaulter.js
// module id = 469
// module chunks = 0